<template>
  <section :style="decoration">
    <div class="ph-16">
      <bl-text-av tag="h2" class="mb-8" variation="heading-24" weight="bold" align="center" color="inverse">
        {{ $options.videoList.title }}
      </bl-text-av>

      <bl-text-av variation="body-14" align="center" color="inverse">
        {{ $options.videoList.subtitle }}
      </bl-text-av>
    </div>

    <div v-if="mutualFundVideos" class="pv-24 ph-16">
      <client-only>
        <div class="u-txt--center mb-8" style="position: relative;" @click="openVideoPopup">
          <img :src="videoImage" style="width: 100%; height: 171px; border-radius: 4px" />
          <div class="play-button">
            <div style="position: relative; width: 100%; height: 100%">
              <ico-play class="play-button__icon" color="#fff" />
            </div>
          </div>
        </div>
      </client-only>

      <bl-text-av variation="body-14" weight="bold">
        Cara Mudah & berkah Berinvestasi Syariah di BukaReksa
      </bl-text-av>

      <template v-if="showVideoPopup">
        <div class="video-popup-bg" />
        <div class="video-popup-wrap">
          <div class="video-popup-container">
            <div class="video-popup-content">
              <bl-button-av variation="primary" class="close-button" @click.native="closeVideoPopup">
                <div slot="icon">
                  <ico-cross-minor color="ink" />
                </div>
              </bl-button-av>
              <youtube :video-id="videoId" :player-width="300" :player-height="200" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';
import { VideoList as videoList } from 'shared/modules/seo/Homepage';
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import BlButtonAv from '@bukalapak/bazaar-mweb-2/dist/components/BlButtonAv';
import ClientOnly from 'vue-client-only';
import IcoPlay from '@bukalapak/bazaar-visual-next/dist/components/IcoPlay';
import IcoCrossMinor from '@bukalapak/bazaar-visual-next/dist/components/IcoCrossMinor';
import { getIdFromURL } from 'vue-youtube-embed';

export default {
  name: 'VideoList',

  videoList,

  components: {
    BlTextAv,
    ClientOnly,
    IcoPlay,
    BlButtonAv,
    IcoCrossMinor,
  },

  data() {
    return {
      showVideoPopup: false,
    };
  },

  computed: {
    mutualFundVideos() {
      return this.$store.state.server.mutualFundVideos;
    },

    videoId() {
      return (this.mutualFundVideos && getIdFromURL(this.mutualFundVideos.url)) || '';
    },

    isSSR() {
      return this.$root.isSSR;
    },

    videoImage() {
      return assetURL('bukareksa-video-thumb.jpg', this.isSSR);
    },

    decoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'top center',
        'background-image': `url(${assetURL('video_list_decoration.png', this.isSSR)})`,
        'background-size': '100%',
        padding: '32px 0',
      };
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundVideos) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundVideos');
    }
  },

  methods: {
    openVideoPopup() {
      this.showVideoPopup = true;
    },
    closeVideoPopup() {
      this.showVideoPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 62px;
  height: 42px;
  background: #3d3d3d;
  border-radius: 10px;
  opacity: 0.7;
  transform: translate(-50%, -50%);

  &__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.video-cover {
  padding-top: 55%; // image ratio: 406/738
  background-size: contain;
  position: relative;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  margin-top: 12px;
  border: 1px solid #eee;
  margin-bottom: 12px;
  overflow: hidden;

  &:hover {
    .video-button {
      opacity: 1;
    }
  }

  .video-button {
    transition: all 0.3s ease 0s;
    opacity: 0.6;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 4.57143rem;
    width: 64px !important;
    height: 64px !important;

    &:hover {
      opacity: 1;
    }
  }
}

.video-popup {
  &-bg {
    opacity: 0.8;
    background: #0b0b0b;
    position: fixed;
    overflow: hidden;
    z-index: 1042;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  &-wrap {
    position: fixed;
    outline: none;
    z-index: 1043;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }

  @media only screen and (max-width: 900px) {
    &-container {
      padding-left: 6px;
      padding-right: 6px;
    }
  }

  &-container {
    text-align: center;
    padding: 0.57143rem;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    position: absolute;
    z-index: 1044;
  }

  &-content {
    z-index: 1045;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.close-button {
  border-radius: 50%;
  opacity: 1;
  cursor: pointer;
  overflow: visible;
  border: 0;
  z-index: 1046;
  width: 24px !important;
  height: 24px !important;
  position: absolute;
  right: -12px;
  top: -28px;
}
</style>
